import { createReducer, createAction } from '@reduxjs/toolkit'

interface SetColumnNumberPayload {
  columns: 'more' | 'less'
}
export const SET_COLUMN_NUMBER = createAction<SetColumnNumberPayload>('list_layout_reducer/set_column_number')

export interface LayoutReducer {
  columns: 'more' | 'less'
  paginationType: 'infinite' | 'paginated'
  isPurchaseMenuOpen: boolean
  isSettingsMenuOpen: boolean
  isSellingVehiclesMenuOpen: boolean
}

const initialState: LayoutReducer = {
  columns: 'less',
  paginationType: 'infinite',
  isPurchaseMenuOpen: true,
  isSettingsMenuOpen: false,
  isSellingVehiclesMenuOpen: false
}

export const SET_IS_PURCHASE_MENU_OPEN = createAction<boolean>('list_layout_reducer/set_is_purchase_menu_open')
export const SET_IS_SETTINGS_MENU_OPEN = createAction<boolean>('list_layout_reducer/set_is_settings_menu_open')
export const SET_IS_SELLING_VEHICLES_MENU_OPEN = createAction<boolean>(
  'list_layout_reducer/set_is_selling_vehicles_menu_open'
)

interface SwitchGridRenderedItemPayload {
  columns: number
}

interface SetPaginationTypePayload {
  paginationType: 'infinite' | 'paginated'
}
export const SET_PAGINATION_TYPE = createAction<SetPaginationTypePayload>('list_layout_reducer/set_pagination_type')

export const SWITCH_GRID_RENDERED_ITEM = createAction<SwitchGridRenderedItemPayload>('list_layout_reducer/switch_grid')

export const layoutReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SET_COLUMN_NUMBER, (state, action) => {
      return { ...state, columns: action.payload.columns }
    })
    .addCase(SET_PAGINATION_TYPE, (state, action) => {
      return { ...state, paginationType: action.payload.paginationType }
    })
    .addCase(SET_IS_PURCHASE_MENU_OPEN, (state, action) => {
      return { ...state, isPurchaseMenuOpen: action.payload }
    })
    .addCase(SET_IS_SETTINGS_MENU_OPEN, (state, action) => {
      return { ...state, isSettingsMenuOpen: action.payload }
    })
    .addCase(SET_IS_SELLING_VEHICLES_MENU_OPEN, (state, action) => {
      return { ...state, isSellingVehiclesMenuOpen: action.payload }
    })
})
